<template>
  <div id="app">
    <Download />
  </div>
</template>

<script>
import Download from './views/Download.vue'
export default {
  components: { Download }
}
</script>
<style lang="scss">
@import '@zz/sasscore/reset.scss';

body {
  background-color: #ededed;
}

#app {
  text-align: center;
}

.nav {
  padding: 30px;

  a {
    font-weight: bold;
    font-size: 32px;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
